import {
  brandShort,
  projectEmail,
  projectHomepage,
  projectIssues,
  projectRepo,
} from '@/../app.config'

const INFO = 'ℹ️'
const BUG = '🐛'
const HANDSHAKE = '👋'

const ASCII_LOGO = `
██       █████  ██████      ██ ██████
██      ██   ██ ██   ██     ██ ██   ██
██      ███████ ██████      ██ ██   ██
██      ██   ██ ██   ██     ██ ██   ██
███████ ██   ██ ██████      ██ ██████
`

export const logWelcomeMessage = () => {
  const homepageLine = projectHomepage ? `\n${projectHomepage}` : ''
  console.info(
    `%c${ASCII_LOGO}%c
Open Data Management Platform for Modern Biology

${brandShort || 'LabID'} is a free and open-source FAIR data management platform for scientists —
covering inventory, biobanking, lab notebooks, datasets, and workflows.

${HANDSHAKE} Project: ${projectRepo || 'contact your administrator'}
${INFO} Contact: ${projectEmail || 'contact your administrator'}
${BUG} Report a bug: ${projectIssues || 'contact your administrator'}

© ${new Date().getFullYear()} EMBL — Multimodal Open Data Integration Support${homepageLine}

`,
    'color:rgb(26, 148, 204); font-family: monospace; font-size: 12px; line-height: 1.4;',
    'color: inherit; font-size: 14px;',
  )
}

export default logWelcomeMessage
